import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';

import { InventoryService } from '@app/core/inventory/services/inventory.service';
import { RfqService } from '@app/core/quotes';

import { AdjustmentEntryFormComponent } from '../adjustment-entry-form/adjustment-entry-form.component';

@Component({
  selector: 'cnc-adjustment-entries',
  templateUrl: './adjustment-entries.component.html',
  styleUrls: ['./adjustment-entries.component.scss'],
})
export class AdjustmentEntriesComponent implements OnInit, OnDestroy {
  initialize :boolean = false;
  loading :boolean = false;
  length = 0;
  pageSize = 20;
  pageSizeOptions :number[] = [5, 10, 25, 100];
  searchKey :string = '';
  pageTitle :string = 'Purchase Orders';

  filter :any = {};
  params :any = {};

  recordSub :Subscription;
  records :any = { data: [] };

  constructor(
    private invSvc :InventoryService,
    private cd :ChangeDetectorRef,
  ) {}

  ngOnInit() {
    this.getRecords();
  }

  ngOnDestroy() {
    this.recordSub.unsubscribe();
  }

  getRecords(event ?:any, page ?:number, paramsOnly ?:boolean) {
    if (this.initialize) {
      return;
    }

    if (page) {
      this.params.page = page;
    }

    this.params = Object.assign(this.params, this.filter);

    if (event) {
      this.params.page = event.pageIndex + 1;
      this.params.per_page = event.pageSize;
    }

    if (paramsOnly) {
      return this.params;
    }

    this.loading = true;
    this.recordSub = this.invSvc
      .getAdjustmentEntries(this.params)
      .subscribe((resp :any) => {
        if (resp.data) {
          this.records = resp;
        }
        this.loading = false;
        this.cd.detectChanges();
      });
  }

  resetFilters() {
    this.filter = {};
    this.params = {
      per_page: 100,
      page: 1,
    };

    this.getRecords(false, 1);
  }
}
